import React from 'react';
import styles from './index.module.css';
import whatsappIcon from '../../assets/whatsapp.png';
import whatsappBck from '../../assets/whatsapp.jpg';

const WhatsappSection = () => {
    return (
        <div className={styles.sectionWhatsapp} style={{ backgroundImage: `url(${whatsappBck})`, backgroundSize: 'cover' }}>
            <div className="container-lg text-center flex flexCol alignCenter">
                <h2>Cotizá tu Alarma por Whatsapp</h2>
                <a href="https://wa.me/541126957356" target="_blank" rel="noopener noreferrer" className={styles.boton}>
                    <img src={whatsappIcon} alt="Whatsapp" />
                    Consultar por WhatsApp
                </a>
                <p>
                    Te damos asesoramiento por especialistas en seguridad de forma
                    GRATUITA
                </p>
            </div>
        </div>
    );
};

export default WhatsappSection;
